var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDisconnect = function SvgIcDisconnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_disconnect_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.857c-6.07 0-11-4.93-11-11s4.93-11 11-11 11 4.93 11 11-4.93 11-11 11Z",
    fill: "#ED5C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 17.297a4.44 4.44 0 1 0 0-8.88 4.44 4.44 0 0 0 0 8.88Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_disconnect_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .857)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcDisconnect;